(function () {
  function initSwiper() {
    var sliders = document.querySelectorAll('.social-ugc-carousel__slider');
    if (!sliders.length) return;

    function runInit() {
      if (typeof window.FoxTheme === 'undefined' || typeof window.FoxTheme.Carousel !== 'function') return;

      sliders.forEach(function (sliderEl) {
        if (sliderEl.swiperInstance) return;

        var slidesMobile = parseInt(sliderEl.dataset.slidesMobile || '1', 10);
        var slidesTablet = parseInt(sliderEl.dataset.slidesTablet || '2', 10);
        var slidesDesktop = parseInt(sliderEl.dataset.slidesDesktop || '3', 10);
        var items = sliderEl.querySelectorAll('.swiper-slide').length;

        var options = {
          slidesPerView: 'auto',
          spaceBetween: 16,
          loop: items > 1,
          loopAdditionalSlides: 3,
          grabCursor: true,
          threshold: 5,
          keyboard: { enabled: true },
          breakpoints: {
            768: { spaceBetween: 6 },
            1024: { spaceBetween: 6 },
          },
        };

        sliderEl.swiperInstance = new window.FoxTheme.Carousel(sliderEl, options);
        sliderEl.swiperInstance.init();
      });
    }

    if (typeof window.FoxTheme !== 'undefined' && typeof window.FoxTheme.Carousel === 'function') {
      runInit();
    } else {
      window.addEventListener('load', runInit);
    }
  }

  function initProductListExpand() {
    if (document.documentElement.dataset.ugcProductsExpandBound === 'true') return;
    document.documentElement.dataset.ugcProductsExpandBound = 'true';

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.social-ugc-carousel__products-expand');
      if (!btn) return;

      var row = btn.closest('.social-ugc-carousel__products-row');
      var list = row && row.querySelector('.social-ugc-carousel__products');
      if (!list) return;

      var expandLabel = btn.getAttribute('data-label-expand') || '';
      var collapseLabel = btn.getAttribute('data-label-collapse') || '';

      var expanded = !list.classList.contains('social-ugc-carousel__products--expanded');
      list.classList.toggle('social-ugc-carousel__products--expanded', expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded && collapseLabel) {
        btn.setAttribute('aria-label', collapseLabel);
      } else if (!expanded && expandLabel) {
        btn.setAttribute('aria-label', expandLabel);
      }

      var iconPlus = btn.querySelector('.social-ugc-carousel__products-expand-icon--plus');
      var iconMinus = btn.querySelector('.social-ugc-carousel__products-expand-icon--minus');
      if (iconPlus) iconPlus.hidden = expanded;
      if (iconMinus) iconMinus.hidden = !expanded;
    });
  }

  function init() {
    initSwiper();
    initProductListExpand();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
